import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api";
import router from "@/router/index";
import store from "@/store/store";

const REPORT_REQUEST_CONFIG = {
    timeout: 60000,
};

function logReportError(type, err) {
    const code = err?.code || err?.name || "UNKNOWN";
    const status = err?.response?.status || "-";
    const message = err?.message || "Unknown error";

    console.error(`[estimate/${type}] request failed`, {
        code,
        status,
        message,
    });
}

const ServerModule = {
    namespaced: true,
    state: {
        isReload :false,
        yourself : null,
        history : null,

        reports : {
            status : [],
            gap : [],
            group : []
        }

    },

    mutations: {
        isReload(state, obj) {
            state.isReload = obj;
        },
        yourself(state, obj) {
            state.yourself = obj;
        },
        history(state, obj) {
            state.history = obj;
        },

        reportsStatus(state, obj) {
            state.reports.status = obj;
        },
        reportsGap(state, obj) {
            state.reports.gap = obj;
        },
        reportsGroup(state, obj) {
            state.reports.group = obj;
        },
    },

    actions: {
        config({commit}, data) {
            return Service.estimatesAssessment('exp', data, {})
                .then((response) => {
                    if(response.data.yourself == true){
                        store.commit("estimate/yourself", response.data.data)
                    }else{
                        store.commit("estimate/history", response.data.data)
                    }
                    return response
                }).catch((err) => {
            });
        },

        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.estimatesAssessment('post', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return response
                    // store.commit("estimate/history", response.data.data)
                }).catch((err) => {
                store.commit("dialog/loading",false)
                throw err
            });
        },

        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.estimatesAssessment('update', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("estimate/history", response.data.data)
                    store.commit("estimate/isReload",false)
                    store.commit("estimate/isReload",true)
                    return response
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },


        reportsStatus({commit}, data) {
            Service.estimatesAssessment('report-status', data, REPORT_REQUEST_CONFIG)
                .then((response) => {
                    store.commit("estimate/reportsStatus", response.data.data)
                }).catch((err) => {
                    logReportError("reportsStatus", err)
            });
        },

        reportsGaps({commit}, data) {
            // store.commit("dialog/loading",true)
            Service.estimatesAssessment('report-gap', data, {})
                .then((response) => {
                    // store.commit("dialog/loading",false)
                    // store.commit("dialog/toasts",1)
                    // store.commit("estimate/isReload",true)
                    store.commit("estimate/reportsGap", response.data.data)
                }).catch((err) => {
                // store.commit("dialog/loading",false)
            });
        },


        reportsGroups({commit}, data) {
            Service.estimatesAssessment('report-group', data, REPORT_REQUEST_CONFIG)
                .then((response) => {
                    store.commit("estimate/reportsGroup", response.data.data)
                }).catch((err) => {
                    logReportError("reportsGroups", err)
            });
        },

    },

    getters: {
        isReload(state, obj) {
            return state.isReload;
        },
        yourself(state, obj) {
            return state.yourself;
        },
        history(state, obj) {
            return state.history;
        },
        reportsStatus(state, obj) {
            return state.reports.status;
        },
        reportsGap(state, obj) {
            return state.reports.gap;
        },
        reportsGroup(state, obj) {
            return state.reports.group;
        },


    },
};

export default ServerModule;
